/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { ExtensibleNode } from '../ExtensibleNode';

/**
 * @author eric.wittmann@gmail.com
 * @class
 * @extends ExtensibleNode
 */
export abstract class Server extends ExtensibleNode {
    public url : string;

    public description : string;

    public variables : any;

    /**
     * Creates a server variable.
     * @param {string} name
     * @return {ServerVariable}
     */
    public abstract createServerVariable(name : string) : ServerVariable;

    /**
     * Adds a server variable.
     * @param {string} name
     * @param {ServerVariable} serverVariable
     */
    public addServerVariable(name : string, serverVariable : ServerVariable) {
        if(this.variables == null) {
            this.variables = <any>({});
        }
        /* put */(this.variables[name] = serverVariable);
    }

    /**
     * Gets a single server variable by name.
     * @param {string} name
     * @return {ServerVariable}
     */
    public getServerVariable(name : string) : ServerVariable {
        if(this.variables != null) {
            return /* get */((m,k) => m[k]===undefined?null:m[k])(this.variables, name);
        }
        return null;
    }

    /**
     * Removes a single server variable and returns it.  This may return null or undefined if none found.
     * @param {string} name
     * @return {ServerVariable}
     */
    public removeServerVariable(name : string) : ServerVariable {
        if(this.variables != null) {
            return /* remove */(map => { let deleted = this.variables[name];delete this.variables[name];return deleted;})(this.variables);
        }
        return null;
    }

    /**
     * Gets a list of all server variables.
     * @return {ServerVariable[]}
     */
    public getServerVariables() : Array<ServerVariable> {
        let rval : Array<ServerVariable> = <any>([]);
        if(this.variables != null) {
            /* addAll */((l1, l2) => l1.push.apply(l1, l2))(rval, /* values */(obj => Object.keys(obj).map(key => obj[key]))(this.variables));
        }
        return rval;
    }

    constructor() {
        super();
        if(this.url===undefined) this.url = null;
        if(this.description===undefined) this.description = null;
        if(this.variables===undefined) this.variables = null;
    }
}
Server["__class"] = "io.apicurio.datamodels.core.models.common.Server";
Server["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];





import { ServerVariable } from './ServerVariable';

